import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import * as enums from '../enums'

export const DOC = gql`
  fragment FragmentFaFunctionCategory on FaFunctionCategory {
    id
    code
    name
    type
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentFaFunctionCategoryFragment,
  ents.extra.common.FaFunction.Category
>({
  code: graphql.transformers.OUT.default(transformers.PASS_THROUGH, ''),
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.extra.common.FaFunction.Category.Id.assertIsId,
    { warnOnly: true },
  ),
  name: graphql.transformers.OUT.default(transformers.PASS_THROUGH, ''),
  type: graphql.transformers.OUT.default(
    enums.type.TRANSFORMER,
    ents.extra.common.FaFunction.Type.Direct,
  ),
})
